import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CourseList.css";
import { API_BASE_URL } from "../config";
import BookCourseCard from "./BookCourseCard.jsx";
import CourseTimeline from "./CourseTimeline.jsx";
import ConsultationModal from "./ConsultationModal.jsx";

function CourseList() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [showConsultModal, setShowConsultModal] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/courses`)
      .then((res) => res.json())
      .then((data) => setCourses(data))
      .catch((err) => console.error("Error fetching courses:", err));
  }, []);

  // Timeline definitions
  const timeline5Days = [
    "Day 1: Documentation + Theory",
    "Day 2: Theory",
    "Day 3: Test + Simulation basic drone assembly",
    "Day 4: Hands on flying + Night flying",
    "Day 5: Hands on flying + Test",
  ];

  const timeline8Days = [
    "Day 1: Documentation + Theory",
    "Day 2: Theory",
    "Day 3: Test + Simulation basic drone assembly",
    "Day 4: Hands on flying + Night flying",
    "Day 5: Hands on flying + Test",
    "Day 6: Test + Simulation",
    "Day 7: Hands on flying + Night flying",
    "Day 8: Hands on flying + Test",
  ];

  // Circle section data
  const highlights = [
    {
      id: 1,
      src: "/Add on Course Images/IMG_6269.jpeg",
      title: "Student Accommodation",
      desc: "50+ students accommodated at a time",
    },
    {
      id: 2,
      src: "/Add on Course Images/WhatsApp Image 2025-06-06 at 1.47.53 PM.jpeg",
      title: "Simulator Room",
      desc: "Exclusive simulator training experience",
    },
    {
      id: 3,
      src: "/service1.webp",
      title: "Hands-on Practice",
      desc: "Exclusive Flying with Expert Instructors",
    },
    {
      id: 4,
      src: "/Add on Course Images/WhatsApp Image 2025-07-08 at 8.25.28 PM.jpeg",
      title: "Modern Equipment",
      desc: "6 Type certificate Drones",
    },
    {
      id: 5,
      src: "/Add on Course Images/library.webp",
      title: "Knowledge Hub",
      desc: "Organized Library Setup",
    },
  ];

  return (
    <div className="courses-wrapper-outer">
      <div className="courses-top-section">
        {/* Hero Header Section */}
        <div className="courses-hero-section">
          <h1 className="courses-hero-title">Premier Training Modules</h1>
        <p className="courses-hero-subtitle">
          Unlock your potential in the skies with our industry-leading DGCA approved courses.
          Step into a professional ecosystem designed for UAV excellence.
        </p>
      </div>

      {/* Courses Section */}
      <div className="courses-container">
        {courses.map((course) => (
          <BookCourseCard
            key={course._id}
            course={{
              name: course.name,
              days: course.days,
              price: course.price,
              gst: course.gst,
              description: course.description,
              image: course.image
                ? `${API_BASE_URL}${course.image}`
                : "/placeholder.png",
            }}
            onApply={() => navigate(`/course-enroll-template/${course._id}`)}
          />
        ))}
      </div>
      </div>

      {/* Professional Timeline Wrapper Container */}
      <div className="common-timeline-section">
        <h2>Course Learning Timeline</h2>

        <div className="timeline-dual-wrapper">
          <CourseTimeline title="5-Day Fast-Track Program" days={timeline5Days} />
          <CourseTimeline title="8-Day Comprehensive Program" days={timeline8Days} />
        </div>
      </div>

      {/* Consultation Section - Premium Professional Layout */}
      <div className="rpc-cta-container">
        <div className="rpc-cta">
          <div className="cta-content-left">
            <h3 className="cta-title-white">Need Personalized Guidance?</h3>
            <p>Talk to our expert trainers and get the right career roadmap for your drone journey today.</p>
          </div>
          <div className="cta-content-right">
            <button onClick={() => setShowConsultModal(true)} className="cta-glass-btn">
              Book Free Consultation
            </button>
          </div>
        </div>
      </div>

      {/* Facility Highlights Section */}
      <div className="circle-section-wrapper">
        <h1 className="circle-heading">World-Class Learning Environment</h1>
        <div className="circle-container">
          {highlights.map((item) => (
            <div className="circle-card" key={item.id}>
              <img src={item.src} alt={item.title} />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {showConsultModal && (
        <ConsultationModal onClose={() => setShowConsultModal(false)} />
      )}
    </div>
  );
}

export default CourseList;
